import PropTypes from "prop-types";
import React from "react";

import { OptimizedImage } from "./OptimizedImage";

export const CarouselContent = ({
  activeIndex,
  sliderImage,
  optimizedImages = null,
  size = "medium",
}) => {
  // Handle both legacy and new image formats
  if (optimizedImages) {
    // New format: use optimizedImages array with OptimizedImage component
    return (
      <section>
        {optimizedImages.map((imageData, index) => (
          <div
            key={index}
            className={`${activeIndex === index ? "slides active" : "inactive"}`}
          >
            <OptimizedImage
              className="slide_image"
              src={imageData}
              alt={`Carousel image ${index + 1}`}
              size={size}
              lazy={false} // Don't lazy load carousel images
            />
          </div>
        ))}
      </section>
    );
  }

  // Legacy format: use plain img tags with URL strings
  const images = sliderImage();
  return (
    <section>
      {images.map((slide, index) => (
        <div
          key={index}
          className={`${activeIndex === index ? "slides active" : "inactive"}`}
        >
          <img className="slide_image" src={slide} alt="" />
        </div>
      ))}
    </section>
  );
};

CarouselContent.propTypes = {
  activeIndex: PropTypes.number,
  sliderImage: PropTypes.func,
  optimizedImages: PropTypes.array,
  size: PropTypes.oneOf(["small", "medium", "large"]),
};
